import { render, staticRenderFns } from "./ShiftAtomFactForm.vue?vue&type=template&id=b596bcfa&"
import script from "./ShiftAtomFactForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomFactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports